module.exports = __webpack_public_path__ + "img/1483134515.91581ea7.jpg";